import React, {useEffect, useState} from "react";
import {LinearProgress, Typography} from "@mui/material";

function WebGLLoader({initialProgression }) {
    const [progression, setProgression] = useState(initialProgression);

    useEffect(() => {
        let intervalId;

        if (progression < 0.9) {
            intervalId = setInterval(() => {
                setProgression((prevProgression) => Math.min(prevProgression + 0.01, 0.9));
            }, 100);
        } else if (progression < 0.99) {
            intervalId = setInterval(() => {
                setProgression((prevProgression) => Math.min(prevProgression + 0.01, 0.99));
            }, 2500);
        }

        return () => clearInterval(intervalId); // Cleanup
    }, [progression]);

    const displayText = progression < 0.9 ? 'Getting ready' : 'Loading procedure';
    const percentageProgress = Math.round(progression * 100);

    return (
        <div className='loader-container'>
            <div className='loader-div'>
                <LinearProgress className='linear-progress' variant="determinate" value={percentageProgress} />
                <Typography variant="caption" component="div" color="white">
                    {`${percentageProgress}%`}
                </Typography>
                <Typography variant="caption" component="div" color="white">
                    {displayText}
                </Typography>
            </div>
        </div>
    );
}

export default WebGLLoader;
